import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IMultiBookingOfferRequestPayload, IMultiTripBookingOfferResponse } from "../../Orchestrator/Types/Interface/IMultiBooking";

export const getMultiTripBookingOffers = async (offerPayload: IMultiBookingOfferRequestPayload) => {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getMultiTripBookingOffersAPI;

  return await apiRequest<IMultiTripBookingOfferResponse>(endpoint, 'POST', {
    body: JSON.stringify(offerPayload),
  });
}
